import script from "./AlertsCurrent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertsCurrent.vue?vue&type=script&setup=true&lang=ts"

import "./AlertsCurrent.vue?vue&type=style&index=0&id=5b55c071&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b55c071"]])

export default __exports__